/* ========================================================================
   Mobile navigation
 ========================================================================== */

app.navMobile = (function () {
  'use strict';

  const _toggles = document.querySelectorAll('[data-mobile-subnav-toggle]');
  const _containers = document.querySelectorAll('[data-mobile-subnav-container]');

  function init() {
    initSubmenus();
    initMenu();
  }

  function openSubmenu(container, toggle) {
    container.style.opacity = 1;
    util.slideDown(container, 250);
    toggle.setAttribute('aria-expanded', true);
  }

  function closeSubmenu(container, toggle) {
    container.style.opacity = 0;
    util.slideUp(container, 250);
    toggle.setAttribute('aria-expanded', false);
  }

  function toggleClickHandler(event) {
    event.preventDefault();

    // Get the ID of the clicked toggle
    const menuId = event.target.getAttribute('aria-controls');

    // Find the corresponding container
    const container = Array.from(_containers).find((container) => {
      return container.id === menuId;
    });

    if (!container) return;

    // Toggle the mega menu based on its current state
    if (event.target.getAttribute('aria-expanded') === 'true') {
      closeSubmenu(container, event.target);
    } else {
      openSubmenu(container, event.target);

      // DATALAYER
      app.dataLayer.pushEvent('primaireNavClick', {
        pageUrl: window.location.pathname,
        destinationUrl: 'Open menu: ' + event.target.dataset.title,
      });
    }
  }

  function initSubmenus() {
    if (!_toggles || !_containers) return;

    // Add event listeners to triggers
    _toggles.forEach((toggle) => {
      toggle.addEventListener('click', toggleClickHandler);
    });
  }

  function initMenu() {
    const trigger = document.querySelector('[data-mobile-nav-trigger]');
    const container = document.querySelector('[data-mobile-nav-container]');

    if (!trigger || !container) return;

    trigger.addEventListener('click', (event) => {
      event.preventDefault();

      if (trigger.getAttribute('aria-expanded') === 'true') {
        container.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', false);
      } else {
        container.classList.add('is-open');
        trigger.setAttribute('aria-expanded', true);
      }
    });
  }

  // Expose public functions and variables
  return {
    init: init,
  };
})();
